/**
 * EntityMeta-related strings.
 */
import React from 'react';

export default {
    d_hide: 'Hide',
    d_show: 'Show',

    d_blameLog: 'Blame Log',
    h_blameLog: '<div><p>The blame log, more generously called the audit log, is a list of changes to this entry since its creation.</p><p>The blame log shows the changes in chronological order, with the name of the user that made the change, the date and time of the change, the fields changed, and the value of the field before and after the change.</p></div>',

    d_created: 'Created',
    d_edited: 'Edited',

    d_createdBy: 'Created By',
    d_editedBy: 'Edited By',

    d_whatChanged: 'What Changed',

    d_foundVersions: (params: {versions: number}) => `Found ${params.versions} version(s)`,

    d_loadingBlameLog: 'Loading blame log from server, hold on...',

    d_serverError: 'The server had issues retrieving data. Here is the specific error:',
};